import { getSourceSite } from "@litonarefin/utils/getSourceSite";
import isEmpty from "lodash/isEmpty";

export function dateStringToMilliseconds(dateString = "") {
  if (!dateString) return "";

  // Split the date and time parts
  const [datePart, timePart, period] = dateString.split(/\s+/);
  const [day, month, year] = datePart.split("/");
  const [hour, minute] = timePart.split(":");

  // Convert hour to 24-hour format
  let hour24 = parseInt(hour, 10);
  if (period.toLowerCase() === "pm" && hour24 !== 12) {
    hour24 += 12;
  } else if (period.toLowerCase() === "am" && hour24 === 12) {
    hour24 = 0;
  }

  // Create a Date object (months are 0-indexed)
  const date = new Date(year, month - 1, day, hour24, minute);

  // Return milliseconds since Unix epoch
  return date.getTime();
}

export function removeLastChar(str = "") {
  let res = str?.charAt(str.length - 1);
  if (res === "/") {
    return str.slice(0, -1);
  } else {
    return str;
  }
}

// Runs in the browser, so it must never reference the backend host: that would
// inline the WordPress URL into the client bundle. The pathname alone is enough
// to match a product_page against the current route.
//
// Returns null when the URL is not a `/{siteSource}_page/<slug>` link, so a
// non-product page (e.g. the backend root) can never match an empty route.
export function getProductPageSlug(url = "", siteSource = "") {
  let pathname;
  try {
    pathname = new URL(url).pathname;
  } catch {
    pathname = url;
  }

  const prefix = `/${siteSource}_page/`;
  if (!pathname?.startsWith(prefix)) return null;

  const slug = removeLastChar(pathname.slice(prefix.length));
  return slug || null;
}

export function getNotificationData(notifications, path) {
  const siteSource = getSourceSite();

  let fullSiteNotification, individualSiteNotification, notification;

  if (notifications?.notification_bar_settings?.full_site_notification?.is_open_notification) {
    fullSiteNotification = notifications?.notification_bar_settings?.full_site_notification;
  }

  individualSiteNotification =
    notifications?.notification_bar_settings?.individual_site_notification;

  if (!isEmpty(individualSiteNotification)) {
    let result;
    individualSiteNotification?.map((item) => {
      const slug = item?.product_page ? getProductPageSlug(item.product_page, siteSource) : null;
      if (slug !== null && path === slug) {
        result = item;
      }
    });

    if (!isEmpty(result) && !!result?.is_open_notification) {
      notification = result;
    } else {
      notification = fullSiteNotification;
    }
  } else {
    notification = fullSiteNotification;
  }

  return { fullSiteNotification, individualSiteNotification, notification };
}

export function checkRepeatDay(start_time, end_time, repeat_day) {
  const startTimeNum = dateStringToMilliseconds(start_time);
  const endTimeNum = dateStringToMilliseconds(end_time);

  const dayCompare = endTimeNum - startTimeNum;

  const dayMs = +repeat_day * 86400000; // 1day

  if (dayCompare <= dayMs) return endTimeNum;
  const numberOfDays = dayCompare / dayMs;

  for (let i = 1; i <= numberOfDays; i++) {
    if (new Date().getTime() < startTimeNum + i * dayMs) {
      return startTimeNum + i * dayMs;
    }
  }

  return endTimeNum;
}
